module.exports = __webpack_public_path__ + "static/media/price_drop.5bb96e5d.svg";